import React, { Component } from 'react'
import _ from 'lodash'
import { toast } from 'react-toastify'

import { Put } from 'utils/axios-token'
import { Get } from 'utils/axios-template'

import Lang from 'Lang/General'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      selectedCenter: null,
      loading: false,
      errorMessageCenter: {},
    }
    onChangeCenterHOC = ( key, val ) => this.setState({ [ key ]: val })

    load = param => this.setState({ loading: param })
    requestSuccess = success => toast.success( success )
    requestError = error => {
      if( typeof error === 'string' ) {
        toast.error( error )
      } else {
        let tmpError = _.reduce( 
          error, 
          ( res, val, key ) => ({ ...res, [ key ]: val.replace( /_/g, ' ' ) }),
          {}
        )
        _.map( tmpError, ( err, errKey ) => toast.error( err ) )
        this.setState({ errorMessageCenter: tmpError })
      }
    }

    getSelectedCenter = () => {
      // Get(
      //   `/centers/${ props.data.selectCenterReducer.selectedCenter.center.client_id }`,
      //   this.getSelectedCenterSuccess,
      //   this.getSelectedCenterError,
      //   this.load
      // )
    }
    getSelectedCenterSuccess = payload => this.setState({ selectedCenter: payload })
    getSelectedCenterError = error => this.requestError( error )

    updateCenter = data => {
      // Put(
      //   `/centers/${ props.data.selectCenterReducer.selectedCenter.center.client_id }`,
      //   data,
      //   this.updateCenterSuccess,
      //   this.updateCenterError,
      //   this.load
      // )
    }
    updateCenterSuccess = () => {
      this.requestSuccess( Lang[ 'SENDER_EMAIL_UPDATE_SUCCESS' ][ this.props.selectedLanguage ] )
      this.getSelectedCenter()
      this.setState({ errorMessageCenter: {} })
    }
    updateCenterError = error => this.requestError( error )

    render = () => {
      return(
        <WrappedComponent
          { ...this.props }
          selectedCenter={ this.state.selectedCenter }
          onLoadCenter={ this.state.loading }
          errorMessageCenter={ this.state.errorMessageCenter }
          onChangeCenterHOC={ this.onChangeCenterHOC }
          getSelectedCenter={ this.getSelectedCenter }
          updateCenter={ this.updateCenter }
        />
      )
    }
  }
  return WithHOC
}
export default HOC
